import React, { useState } from 'react';
import Tons from '../../../assets/Tons';
import CheckmarkSmall from '../../../assets/CheckmarkSmall';
import ProductStoreStep from './components/ProductStoreStep';
import ProductDetailsStep from './components/ProductDetailsStep';
import { SypacButton, SypacText } from '@sypac/component-library-react';
import { T } from '@tolgee/react';
import { UpdatedProduct } from '../../../services/product.services';
import { useNavigate } from 'react-router-dom';
import ProductGroupStep from './components/ProductGroupStep';
import ProductCategoryStep from './components/ProductCategoryStep';

const AddNewProduct: React.FC = () => {
	const [step, setStep] = useState<number>(1);
	const [product, setProduct] = useState<UpdatedProduct>();
	const navigate = useNavigate();

	const SuccessMessage = () => (
		<section className="w-full h-full flex items-center justify-center">
			<div className="w-[410px] flex flex-col gap-[60px]">
				<div className="relative flex">
					<Tons width={36} height={42} />
					<span className="absolute top-[24px] left-[22px] flex border-[2px] border-solid border-white rounded-full">
						<CheckmarkSmall color="#20AC93" />
					</span>
				</div>

				<div className="flex flex-col gap-6">
					<SypacText variant="body-normal-medium">
						<p className="text-xl text-gray-80">
							<T keyName="addNewProduct.newProductUploaded">
								New product type successfully uploaded
							</T>
						</p>
					</SypacText>
				</div>

				<div className="w-full flex flex-col gap-3 p-[10px] border border-solid border-gray-10 rounded-xl box-border">
					<div
						style={{
							backgroundImage: `url(${product?.photoUrl})`,
						}}
						className="w-full h-[174px] bg-no-repeat bg-cover bg-center border border-solid border-gray-10 rounded-10 box-border"
						role="img"
						aria-label={product?.name}
					/>

					<div className="flex flex-col gap-[10px]">
						<SypacText variant="body-regular-medium">
							<p className="text-gray-80">{product?.name}</p>
						</SypacText>

						{product?.type ? (
							<SypacText variant="body-regular-medium">
								<p className="text-sm text-gray-40">
									{product.type} ({product.size})
								</p>
							</SypacText>
						) : null}
					</div>
				</div>

				<footer className="flex w-full gap-3 [&_button]:transition">
					{[
						{ key: 'modalAddProduct.close', label: 'Close' },
						{
							key: 'modalAddProduct.viewInStore',
							label: 'View in store',
							primary: true,
						},
					].map(({ key, label, primary }) => (
						<SypacButton
							key={key}
							variant={primary ? 'primary' : 'secondary'}
							size="small"
							className="w-full"
						>
							<button
								type="button"
								className={`w-full ${
									primary ? 'py-2.75' : 'py-2.5'
								} rounded-lg`}
								onClick={() => navigate('/product-database')}
							>
								<SypacText
									variant="body-regular-medium"
									className={primary ? 'text-white' : ''}
								>
									<p>
										<T keyName={key}>{label}</T>
									</p>
								</SypacText>
							</button>
						</SypacButton>
					))}
				</footer>
			</div>
		</section>
	);

	const renderSteps = () => {
		const stepComponents = [
			<ProductStoreStep setStep={setStep} />,
			<ProductGroupStep setStep={setStep} />,
			<ProductCategoryStep setStep={setStep} />,
			<ProductDetailsStep setStep={setStep} setProduct={setProduct} />,
		];
		return step <= 4 ? stepComponents[step - 1] : <SuccessMessage />;
	};

	return (
		<main className="w-full h-full flex items-center justify-center">
			{renderSteps()}
		</main>
	);
};
export default AddNewProduct;
